import { computed, inject, InjectionToken, Signal } from '@angular/core';
import { KioskGlobalSettings } from '@core/models/kiosk-global-settings.model';

const KioskGlobalSettingsToken = new InjectionToken<Signal<KioskGlobalSettings>>(
  'Expose Kiosk Global Settings, it is provided at kiosk main layout level and accessible for all descendants',
);

export function injectKioskGlobalSettings() {
  const kioskGlobalSettings = inject(KioskGlobalSettingsToken, {
    optional: true,
  });
  const kioskGlobalSettingsWithDefaultValues = computed<KioskGlobalSettings>(() => ({
    stepperProductComposition: {
      autoAddToCart: kioskGlobalSettings?.()?.stepperProductComposition.autoAddToCart ?? false,
      hideNextButtonIfTheRequiredQuantityIsOne:
        kioskGlobalSettings?.()?.stepperProductComposition
          .hideNextButtonIfTheRequiredQuantityIsOne ?? false,
    },
  }));
  return kioskGlobalSettingsWithDefaultValues;
}

export function provideKioskGlobalSettingsToken(
  kioskGlobalSettings: () => Signal<Partial<KioskGlobalSettings> | undefined>,
) {
  return {
    provide: KioskGlobalSettingsToken,
    useFactory: kioskGlobalSettings,
  };
}
